import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function SvgMapLocation(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    stroke: "inherit",
    fill: "inherit",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M9.913 22.583l6.317-6.34c3.461-3.475 3.461-9.11.001-12.583l-.054-.054-.001-.002a8.832 8.832 0 00-12.527.002l-.053.053c-3.461 3.474-3.461 9.109 0 12.583l6.317 6.341z",
    stroke: props.stroke,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M12.512 9.913a2.604 2.604 0 01-2.599 2.609 2.604 2.604 0 01-2.6-2.609 2.604 2.604 0 012.6-2.609 2.604 2.604 0 012.599 2.609z",
    fill: props.background,
    stroke: props.background
  })));
}
const MemoSvgMapLocation = React.memo(SvgMapLocation);
MemoSvgMapLocation.defaultProps = {
  background: '#fff'
};
export default MemoSvgMapLocation;